import type { ThemePreset } from "../types";

export const midnight: ThemePreset = {
  id: "midnight",
  name: "Mitternacht",
  nameKey: "admin.settings.appearance.themes.midnight.name",
  description: "Elegante dunkle Blautöne",
  descriptionKey: "admin.settings.appearance.themes.midnight.description",
  light: {
    background: "oklch(0.985 0.005 250)",
    foreground: "oklch(0.15 0.02 250)",
    card: "oklch(1 0 0)",
    "card-foreground": "oklch(0.15 0.02 250)",
    popover: "oklch(1 0 0)",
    "popover-foreground": "oklch(0.15 0.02 250)",
    primary: "oklch(0.45 0.15 260)",
    "primary-foreground": "oklch(0.985 0 0)",
    secondary: "oklch(0.95 0.015 250)",
    "secondary-foreground": "oklch(0.20 0.02 250)",
    muted: "oklch(0.95 0.012 250)",
    "muted-foreground": "oklch(0.50 0.02 250)",
    accent: "oklch(0.92 0.02 255)",
    "accent-foreground": "oklch(0.20 0.02 250)",
    destructive: "oklch(0.577 0.245 27.325)",
    "destructive-foreground": "oklch(0.985 0 0)",
    border: "oklch(0.91 0.015 250)",
    input: "oklch(0.91 0.015 250)",
    ring: "oklch(0.45 0.15 260)",
    "sidebar-background": "oklch(0.98 0.006 250)",
    "sidebar-foreground": "oklch(0.30 0.02 250)",
    "sidebar-primary": "oklch(0.45 0.15 260)",
    "sidebar-primary-foreground": "oklch(0.985 0 0)",
    "sidebar-accent": "oklch(0.93 0.018 250)",
    "sidebar-accent-foreground": "oklch(0.20 0.02 250)",
    "sidebar-border": "oklch(0.91 0.015 250)",
    "sidebar-ring": "oklch(0.45 0.15 260)",
  },
  dark: {
    background: "oklch(0.15 0.025 255)",
    foreground: "oklch(0.92 0.01 250)",
    card: "oklch(0.18 0.025 255)",
    "card-foreground": "oklch(0.92 0.01 250)",
    popover: "oklch(0.18 0.025 255)",
    "popover-foreground": "oklch(0.92 0.01 250)",
    primary: "oklch(0.65 0.15 250)",
    "primary-foreground": "oklch(0.15 0.02 255)",
    secondary: "oklch(0.22 0.025 255)",
    "secondary-foreground": "oklch(0.90 0.01 250)",
    muted: "oklch(0.22 0.02 255)",
    "muted-foreground": "oklch(0.62 0.02 250)",
    accent: "oklch(0.25 0.03 255)",
    "accent-foreground": "oklch(0.92 0.01 250)",
    destructive: "oklch(0.55 0.22 27)",
    "destructive-foreground": "oklch(0.98 0 0)",
    border: "oklch(0.28 0.025 255)",
    input: "oklch(0.28 0.025 255)",
    ring: "oklch(0.65 0.15 250)",
    "sidebar-background": "oklch(0.12 0.025 255)",
    "sidebar-foreground": "oklch(0.80 0.015 250)",
    "sidebar-primary": "oklch(0.65 0.15 250)",
    "sidebar-primary-foreground": "oklch(0.15 0.02 255)",
    "sidebar-accent": "oklch(0.20 0.025 255)",
    "sidebar-accent-foreground": "oklch(0.92 0.01 250)",
    "sidebar-border": "oklch(0.25 0.025 255)",
    "sidebar-ring": "oklch(0.65 0.15 250)",
  },
};
